import {takeEvery, put, select} from 'redux-saga/effects';
import {DONE_ADD_TO_HOME_SCREEN} from "../constants/popup.constants";
import {triggerPWAInstall} from "../helpers/pwa-helper";
import {ADD_TO_HOME_SCREEN_FROM_SETTINGS} from "../constants/pwa.constants";
import Platform from '../platform';
import {openAddToHomeScreen} from "../actions/popup.actions";
import {START} from "../constants/app-state.constants";
import {getCurrentSessionTimeSelector} from "../selectors";

function* installPWA() {
	triggerPWAInstall();
}

function* installPWAOrOpenPropmpt() {
	if (Platform.isAndroid) {
		triggerPWAInstall();
	} else if (Platform.isIOs) {
		yield put(openAddToHomeScreen());
	}
}

function* suggestPWAInstall() {
	const state = yield select();

	const currentSessionTime = getCurrentSessionTimeSelector(state);

	const FrequentUsageMaxInterval = (1000 * 60 * 60 * 24) * 30; //30 days

	const isAppUsedFrequently = currentSessionTime.startTimestamp - currentSessionTime.previousStartTimestamp < FrequentUsageMaxInterval;

	if ((isAppUsedFrequently && !Platform.isIOs) ||
		(Platform.isIOs && !state.pwaPrompt.isShownOnce)) {
		yield put(openAddToHomeScreen());
	}
}

export const pwaSaga = function* pwaSaga() {
	yield takeEvery([START], suggestPWAInstall);
	yield takeEvery([DONE_ADD_TO_HOME_SCREEN], installPWA);
	yield takeEvery([ADD_TO_HOME_SCREEN_FROM_SETTINGS], installPWAOrOpenPropmpt)
};
